export default {
  methods: {
    contactUs() {
      window.location.href = "https://worldgreaservice.com/index/index/home?visiter_id=&visiter_name=&avatar=&business_id=2&groupid=2&special=10";
    }
  }
}